import './LoadingScreen.css';

/** Full-bleed loading state, used while the session resolves. */
export function LoadingScreen({ label = 'Loading' }: { label?: string }) {
  return (
    <div className="loading-screen" role="status" aria-live="polite">
      <span className="loading-screen__pulse" aria-hidden="true" />
      <span className="loading-screen__label">{label}</span>
    </div>
  );
}
